import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor() {}

  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(error.message)) {
      console.warn(`Reloading due to chunk loading error! GlobalErrorHandlingService`);
      // window.location.reload()
    }
    console.error(error);
  }
}
